import script from "./stat-box.vue?vue&type=script&setup=true&lang=js"
export * from "./stat-box.vue?vue&type=script&setup=true&lang=js"

import "./stat-box.vue?vue&type=style&index=0&id=bf8d1df6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf8d1df6"]])

export default __exports__